import { Switch, Route } from 'react-router-dom';
import React from 'react';
import { HomePage } from '../pages';

export interface HomeLayoutProps {
  match?: any;
}

const HomeLayout: React.FC<HomeLayoutProps> = ({ match }) => {
  return (
    <Switch>
      <Route exact path={`${match.path}/`} component={HomePage} />
    </Switch>
  );
};

export default HomeLayout;
